import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Button,
  Table,
} from "reactstrap";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as orderActions from './actions'
import * as common from '../../lib/common'
import ButtonExt from "../controls/ButtonExt"
import { BtnPermissions } from '../../lib/BtnPermissions'
import orderConstants, * as constants from "./constants"
import { storedb } from '../../views/client/storedb'
import OrderCustomerInfo from "./_OrderCustomerInfo"
import OrderApproveCfm from "./_OrderApproveCfm"
import OrderHistory from "./_OrderHistory"
import AppConfig from '../../config/app'

var dbContext;
class OrderDetails extends Component {
  constructor(props) {
    super(props);
    dbContext = storedb();
    this._isMounted = false
    this.state = {
      donHangId: '',
      hasChanged: false,
      modalApprove: false,
      modalReturnItems: false,
      modalHistory: false,
      isShowMoreContent: true,
      showMoreClass: 'order-show-more',
      isReadyClick: true,
      showCkPercent: dbContext.getSettingValue(AppConfig.SETTINGKEYS.ShowCkPercent, "0")
    }
  }

  checkParamsOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const mode = orderConstants.MODE.IN_VIEW
      const { type, id } = params;
      this.props.setTypeOrder(+type)
      this.props.setOrderId(id)

      this.props.setMode(mode)

      this.setState({ hasChanged: true }, () => {
        callback(mode, id)
      })
    }
  }
  setShowHide = () => {
    const { isShowMoreContent } = this.state
    if (isShowMoreContent) {
      this.setState({ showMoreClass: 'animated', isShowMoreContent: false })
    } else {
      this.setState({ showMoreClass: 'order-show-more', isShowMoreContent: true })
    }
  }
  addHoaDonClick = () => {
    const type = this.props.typeOfOrder || orderConstants.TYPEOF_ORDER.FOR_DEFAULT
    this.props.history.push(`/order/${type}`)
  }
  editClick = () => {
    const type = this.props.typeOfOrder || orderConstants.TYPEOF_ORDER.FOR_DEFAULT;
    this.props.history.push(`/order-edit/${type}/${this.props.orderId}`);
  }
  // in đơn hàng
  printOrderData = () => {
    const formData = {
      order_id: this.state.donHangId,
      store_id: dbContext.getStoreId()
    }
    this.props.loadOrderExport(formData);
  }
  // xem lich sư giao hàng 
  searchOrderHistoryData = () => {
    const formData = {
      order_id: this.state.donHangId,
      store_id: dbContext.getStoreId(),
      page: 1,
      per_page: 20
    }
    this.props.loadOrderHistory(formData);
  }
  historyClick = (orderInfor) => {
    this.setState({ donHangId: orderInfor.order_id }, () => {
      this.searchOrderHistoryData();
      this.setState({ modalHistory: true });
    })
  }
  // xác nhận thu tiền của đơn hàng
  confirmReceivedMoney = (res) => {
    const formData = {
      GiaoHangId: res.GiaoHangId,
      TrangThai: res.DaNhanTien == 0 ? 1 : 0
    }
    this.props.SetOrderConfirmMoney(formData, () => {
      this.searchOrderHistoryData();
    })
  }
  // excel đơn hàng
  exportXls = (orderInfor) => {
    const formData = {
      orderId: orderInfor.order_id,
    }
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "donhang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("Ten file", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    this.props.loadOrderExcel(formData, dialogSaveFile)
  }
  printClick = (orderInfor) => {
    this.setState({ donHangId: orderInfor.order_id }, () => {
      this.printOrderData();
    })
  }
  closeDlgHistory = () => {
    this.setState({
      modalHistory: !this.state.modalHistory,
    });
  }

  // chuyển đơn từ đang xử lý sang hoàn thành nhập
  convertOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>XÁC NHẬN?</h1>
            <p>Duyệt đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này vào hệ thống?<br />
              Đơn sẽ được chuyển thành đang xử lý, số lượng tồn trong kho sẽ bị thay đổi.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                order_id: item.order_id
              }
              const convertSuccess = () => {
                this.setState({ isReadyClick: false })
                setTimeout(this.fetchData, 1500)
              }
              this.props.convertOrder(formData, convertSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // chuyển đơn từ đang xử lý sang hoàn thành nhập
  revertOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn trả lại đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?<br />
              Việc này đồng nghĩa đơn hàng này sẽ được gửi lại người đánh đơn.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id
              }
              this.props.setCallbackFunc(() => {
                this.setState({ isReadyClick: false })
                setTimeout(this.fetchData, 1500)
              })
              this.props.revertOrder(formData)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // xoá đơn hàng với những đơn chưa tiếp nhận xử lý
  deleteClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xoá đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?<br />
              Việc này đồng nghĩa đơn hàng này sẽ được xoá bỏ khỏi hệ thống.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id
              }
              const callOnSuccess = () => {
                this.setState({ isReadyClick: false })
                setTimeout(this.return2List, 1500)
              }
              this.props.deleteOrder(formData, callOnSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // huỷ đơn hàng với những đơn chưa tiếp nhận xử lý
  cancelClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn huỷ đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?<br />
              Việc này đồng nghĩa đơn hàng này sẽ đưa về trạng thái huỷ.
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id
              }
              const callOnSuccess = () => {
                this.setState({ isReadyClick: false })
                setTimeout(this.return2List, 1500)
              }
              this.props.cancelOrder(formData, callOnSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // Tiếp nhận xử lý đơn hàng, đơn hàng sẽ chuyển từ hoàn thành nhập sang đang xử lý
  processOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Tiếp nhận xử lý đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id
              }
              const processSuccess = () => {
                this.setState({ isReadyClick: false })
                setTimeout(this.fetchData, 1500)
              }
              this.props.processOrder(formData, processSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // hoàn thành đơn hàng, đơn hàng sẽ chuyển sang trạng thái hoàn thành
  approveOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Duyệt hoàn thành đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này không?
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.store_id,
                order_id: item.order_id,
                ghi_chu: item.ghi_chu,
                da_thanh_toan: item.da_thanh_toan,
                noi_xuat: item.noi_xuat,
                ngay_giao: common.parseDatetime(item.ngay_giao).unix(),
              }
              const approveSuccess = () => {
                this.setState({ isReadyClick: false })
                setTimeout(() => {
                  this.fetchData()
                  this.toggleApprove()
                }, 1500)
              }
              this.props.approveOrder(formData, approveSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  // huỷ bỏ lock đơn hàng, danh cho trường hợp đang mở chỉnh sửa mà quên chưa lưu lại
  unlockOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Huỷ quá trình cập nhật đơn hàng <b className="text-danger">{item.ma_don_hang}</b> này?
            </p>
            <button className="text-danger" onClick={() => {
              const payload = {
                orderId: this.props.orderId,
                typeOfOrder: this.props.typeOfOrder
              }
              this.props.unlockOrder(payload, () => {
                setTimeout(this.fetchData, 1500)
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  // hoàn thành đơn hàng, đơn hàng sẽ chuyển sang trạng thái hoàn thành
  toggleApprove = e => {
    if (!this.state.modalApprove) {
      this.setState(() => ({
        modalApprove: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        modalApprove: false,
      }));
    }
  }

  return2List = () => {
    const type = this.props.typeOfOrder || orderConstants.TYPEOF_ORDER.FOR_DEFAULT;
    this.props.history.push(`/orders/${type}`);
  }
  // open page trả hàng
  gotoReturnItems = e => {
    const type = this.props.typeOfOrder || orderConstants.TYPEOF_ORDER.FOR_DEFAULT;
    const url = `/tra-hang/${type}/${this.props.orderId}`
    this.props.history.push(url);
  }

  fetchData = (mode, orderId) => {
    const payload = {
      orderId: orderId || this.props.orderId,
      mode: mode || this.props.mode
    }
    this.setState({ isReadyClick: true })
    this.props.getOrderDetails(payload)
  }
  componentDidMount() {
    this._isMounted = true
    // fetch data
    this.checkParamsOrder((mode, orderId) => {
      if (this._isMounted) {
        this.fetchData(mode, orderId)
      }
    })
  }

  componentWillUnmount() {
    this._isMounted = false
    // reset callback func
    this.props.setCallbackFunc(() => { })
  }
  render() {
    const sumQuantity = () => {
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "so_luong").toLocaleString()
    }
    const sumRefun = (isShowSumValue) => {
      if (!isShowSumValue) {
        return ""
      }
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "chiet_khau").toLocaleString()
    }
    const sumFee = () => {
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "thanh_tien").toLocaleString()
    }
    const sumScore = () => {
      const items = this.props.orderInfor.items || [];
      return common.sum(items, "diem").toLocaleString()
    }
    const genTongCKDon = e => {
      const orderTotal = this.props.orderInfor || {};
      if (typeof orderTotal != "undefined") {
        return (
          <Fragment>
             <tr key={"ft4"}>
              <td colSpan="4" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Tổng tiền: </span>
              </td>
              <td scope="col" className="text-right font-weight-bold"></td>
              <td scope="col" className="text-right font-weight-bold">
                {(orderTotal.tong_tien || 0).toLocaleString()}
              </td>
            </tr>
            <tr key={"ft2"}>
              <td colSpan="4" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Chiết khấu:	 </span>
              </td>
              <td></td>
              <td scope="col" className="text-right font-weight-bold">
              {(orderTotal.chiet_khau || 0).toLocaleString()}
              </td>
            </tr>
            <tr key={"ft3"}>
              <td colSpan="4" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Thanh toán: </span>
              </td>
              <td scope="col" className="text-right font-weight-bold">
               
              </td>
              <td scope="col" className="text-right font-weight-bold">
                {(orderTotal.chiet_khau_doanh_so || 0).toLocaleString()}
              </td>
            </tr>
           
          </Fragment>
        )
      }
    }
    const getItems = e => {
      const items = this.props.orderInfor.items || [];
      return items.map((item, idx) => {
        return (
          <tr key={idx}>
            <td scope="col" className="text-justify">
              {`${item.sku}/ ${item.ten_hang}`}
            </td>
            <td scope="col" className="text-justify">
              {item.dvt}
            </td>
            <td scope="col" className="text-right">
              {item.so_luong.toLocaleString()}
            </td>
            <td scope="col" className="text-right">
              {item.gia_ban.toLocaleString()}
            </td>
            {this.props.orderInfor.bo_chiet_khau && (
              <td scope="col" className="text-right">
                {item.diem}
              </td>
            )}
            {!this.props.orderInfor.bo_chiet_khau && (
              <td scope="col" className="text-right">
                {item.chiet_khau ? item.chiet_khau.toLocaleString() : ''}
              </td>
            )}
            <td scope="col" className="text-right">
              {item.thanh_tien.toLocaleString()}
            </td>
          </tr>
        )
      });
    }

    const {
      requesting,
      orderInfor,
      errors,
      messages,
      typeOfOrder,
    } = this.props
    const {
      showMoreClass,
      isShowMoreContent,
      isReadyClick,
      showCkPercent,
    } = this.state

    const isShowCKPercent = showCkPercent === "1"
    const isEditable = orderInfor && orderInfor.is_editable
    const isLocking = orderInfor && orderInfor.is_locking
    let msgLocking = ''
    if (isLocking) {
      const userId = dbContext.info.Id
      const lockById = orderInfor ? orderInfor.lock_by_id : 0
      if (lockById === userId) {
        msgLocking = `Đơn đang được sửa bởi (${orderInfor.lock_by}) ở thời điểm trước đó. Bấm [Huỷ] để thao tác lại.`
      } else {
        msgLocking = `Đơn đang được sửa bởi ${orderInfor.lock_by}`
      }
    }
    const genLinkViewOrders = (codes) => {
      if (!codes) {
        return null
      }
      return codes.map((item, i) => {
        const type = item.loai_hd || orderConstants.TYPEOF_ORDER.FOR_RETURN;
        return (
          <a key={i} target="_blank" className="ml-1 mr-1" href={`/#/order-view/${type}/${item.order_id}`}>
            <b>{item.ma_don_hang}</b>
          </a>
        )
      })
    }
    const genGhiChuRegion = (item) => {
      const type = typeOfOrder || orderConstants.TYPEOF_ORDER.FOR_DEFAULT
      const textRefer = type === orderConstants.TYPEOF_ORDER.FOR_RETURN ? "Đơn gốc" : "Đơn trả hàng"
      if (item.tra_hang_codes && item.tra_hang_codes.length > 0) {
        return (
          <Fragment>
            <div className="col-sm-6  pull-left view-row mb-2">
              <span>{textRefer}: </span>{genLinkViewOrders(item.tra_hang_codes)}
            </div>
            <div className="col-sm-12 mb-2 pull-left view-row">
              <span>Ghi chú: <b>{item.ghi_chu}</b></span>
            </div>
          </Fragment>
        )
      } else {
        return (
          <div className="col-sm-6 mb-2 pull-left view-row">
            <span>Ghi chú: <b>{item.ghi_chu}</b></span>
          </div>
        )
      }
    }
    return (
      <div className="animated fadeIn order">
        <BlockUi tag="div" blocking={requesting}>
          <div className="col-sm-7 col-md-8 pull-left order-view">
            <Card>
              <CardBody className="p-1">
                <div className="col-sm-12">
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Mã đơn hàng: <b>{orderInfor.ma_don_hang}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Trạng thái: {common.getOrdetStatusText(orderInfor.trang_thai, true)}</span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Nhân viên: <b>{orderInfor.ten_nhan_vien}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Ngày lập: <b>{common.formatDateTime(orderInfor.ngay_lap, "HH:mm DD/MM/YYYY")}</b></span>
                  </div>
                  <div className={`col-sm-6 mb-2 pull-left view-row ${showMoreClass}`}>
                    <span>Ngày giao: <b>{orderInfor.ngay_giao ? common.formatDateTime(orderInfor.ngay_giao, "DD/MM/YYYY") : ""}</b></span>
                  </div>
                  <div className={`col-sm-6 pull-left view-row mb-2 ${showMoreClass}`}>
                    <span>Kí H/Đồng: <b>{orderInfor.bo_chiet_khau ? 'Có' : "Không"}</b></span>
                  </div>
                  <div className={`col-sm-6 pull-left view-row mb-2 ${showMoreClass}`}>
                    <span>Xuất hóa đơn: <b>{orderInfor.xuat_hoa_don ? 'Có' : 'Không'}</b></span>
                  </div>
                  {genGhiChuRegion(orderInfor)}
                </div>
                <OrderCustomerInfo
                  className="show-in-mobile"
                  typeOfOrder={this.props.typeOfOrder}
                  orderInfor={orderInfor}
                  isLocking={isLocking}
                  msgLocking={msgLocking}
                  isEditable={isEditable}
                  showMoreClass={showMoreClass}
                  isShowMoreContent={isShowMoreContent}
                  unlockOrder={this.unlockOrderClick}
                  setShowHide={this.setShowHide}
                />
                <div className="clearfix"></div>
                <div className="col-sm-12 mb-2">
                  <Table hover responsive className="table-outline table-sm mb-0">
                    <thead className="thead-default">
                      <tr className="hide-in-mobile">
                        <th scope="col" className="text-justify">
                          Tên thuốc
                        </th>
                        <th scope="col" className="text-justify">
                          ĐVT
                        </th>
                        <th scope="col" className="text-right">
                          Số lượng
                        </th>
                        <th scope="col" className="text-right">
                          Đơn gía
                        </th>
                        {orderInfor.bo_chiet_khau && (
                          <th scope="col" className="text-right">
                            Điểm
                          </th>
                        )}
                        {!orderInfor.bo_chiet_khau && (
                          <th scope="col" className="text-right">
                            C/khấu {isShowCKPercent ? "(%)" : ""}
                          </th>
                        )}
                        <th scope="col" className="text-right">
                          Thành tiền
                        </th>
                      </tr>
                      <tr className="show-in-mobile">
                        <th scope="col" className="text-justify">
                          Tên
                        </th>
                        <th scope="col" className="text-justify">
                          ĐVT
                        </th>
                        <th scope="col" className="text-right">
                          S/lượng
                        </th>
                        <th scope="col" className="text-right">
                          Đ/gía
                        </th>
                        {orderInfor.bo_chiet_khau && (
                          <th scope="col" className="text-right">
                            Điểm
                          </th>
                        )}
                        {!orderInfor.bo_chiet_khau && (
                          <th scope="col" className="text-right">
                            C/khấu {isShowCKPercent ? "(%)" : ""}
                          </th>
                        )}
                        <th scope="col" className="text-right">
                          T/tiền
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {getItems()}
                    </tbody>
                    <tfoot className="thead-default">
                      <tr>
                        <td colSpan="1" scope="col" className="text-right">
                          <span className="text-primary font-weight-bold">Tổng<label className="d-none"> cộng</label>: </span>
                        </td>
                        <td colSpan="2" scope="col" className="text-right font-weight-bold">
                          {sumQuantity()}
                        </td>
                        {orderInfor.bo_chiet_khau && (
                          <td colSpan="2" scope="col" className="text-right font-weight-bold">
                            {sumScore()}
                          </td>
                        )}
                        {!orderInfor.bo_chiet_khau && (
                          <td scope="col" colSpan="2" className="text-right font-weight-bold">
                            {sumRefun(!isShowCKPercent)}
                          </td>
                        )}
                        <td scope="col" className="text-right font-weight-bold">
                          {sumFee()}
                        </td>
                      </tr>
                      {genTongCKDon()}
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
              {!requesting && isReadyClick && (
                <CardFooter className="pr-1 pl-1">
                  <div>
                    <div className="col-sm-12">
                      {!!errors.length && (
                        <Errors message="Failure to signup due to:" errors={errors} />
                      )}
                      {!!messages.length && (
                        <Messages messages={messages} />
                      )}
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div role="group">
                      <Button className="btn btn-secondary mr-1 mb-1" onClick={() => this.return2List()}>
                        <i className="fa fa-history"></i> Quay về
                      </Button>
                      {isEditable && orderInfor.c_edt && (
                        <ButtonExt size="md" btnClass="btn btn-warning mr-1" btnClick={() => this.editClick(orderInfor)}
                          iconClass="fa-pencil" displayText="Sửa"
                          permission={BtnPermissions.DonHang.SAVE_ORDER} />
                      )}
                      {isEditable && orderInfor.c_tct && (
                        <ButtonExt size="md" btnClass="btn btn-warning mr-1" btnClick={() => this.convertOrderClick(orderInfor)}
                          iconClass="fa-check" displayText="Xử lý đơn"
                          permission={BtnPermissions.DonHang.PROCESS_ORDER} />
                      )}
                      {isEditable && orderInfor.c_rvt && (
                        <ButtonExt size="md" btnClass="btn btn-default mr-1" btnClick={() => this.revertOrderClick(orderInfor)}
                          iconClass="fa-reply-all" displayText="Trả lại"
                          permission={BtnPermissions.DonHang.SAVE_ORDER} />
                      )}
                      {isEditable && orderInfor.c_prc && (
                        <ButtonExt size="md" btnClass="btn btn-info mr-1" btnClick={() => this.processOrderClick(orderInfor)}
                          iconClass="fa-check" displayText="Xử lý đơn"
                          permission={BtnPermissions.DonHang.PROCESS_ORDER} />
                      )}
                      {isEditable && orderInfor.c_apr && (
                        <ButtonExt size="md" btnClass="btn btn-success mr-1" btnClick={() => this.toggleApprove(orderInfor)}
                          iconClass="fa-check" displayText="Hoàn thành"
                          permission={BtnPermissions.DonHang.APPROVE_ORDER} />
                      )}
                      {isEditable && orderInfor.c_rtn && (
                        <ButtonExt size="md" btnClass="btn btn-warning mr-1" btnClick={() => this.gotoReturnItems(orderInfor)}
                          iconClass="fa-mail-reply" displayText="Trả hàng"
                          permission={BtnPermissions.DonHang.RETURN_ORDER_ITEMS} />
                      )}
                      {orderInfor.c_dlt && (
                        <ButtonExt size="md" btnClass="btn btn-danger mr-1" btnClick={() => this.deleteClick(orderInfor)}
                          iconClass="fa-remove" displayText={"Xoá"}
                          permission={BtnPermissions.DonHang.DELETE_ORDER} />
                      )}
                      {orderInfor.c_ccl && (
                        <ButtonExt size="md" btnClass="btn btn-danger mr-1" btnClick={() => this.cancelClick(orderInfor)}
                          iconClass="fa-remove" displayText={"Huỷ"}
                          permission={BtnPermissions.DonHang.CANCEL_ORDER} />
                      )}
                      {orderInfor.c_htr && (
                        <ButtonExt size="md" btnClass="btn btn-info mr-1" btnClick={() => this.historyClick(orderInfor)}
                          iconClass="fa-clock-o" displayText="Ls g/hàng"
                          permission={""} />
                      )}
                      {orderInfor.c_prt && [
                        (
                          <ButtonExt key="1" size="md" btnClass="btn btn-success mr-1" btnClick={() => this.exportXls(orderInfor)}
                            iconClass="fa-file-excel-o" displayText="Xuất excel" color="success"
                            permission={""} />
                        ),
                        (
                          <ButtonExt key="2" size="md" btnClass="btn btn-success mr-1" btnClick={() => this.printClick(orderInfor)}
                            iconClass="fa-print" displayText="In đơn"
                            permission={""} />
                        )
                      ]}
                      <ButtonExt size="md" btnClass="btn btn-primary mr-1" btnClick={this.addHoaDonClick}
                        iconClass="fa-plus" displayText="Thêm đơn"
                        permission={BtnPermissions.DonHang.SAVE_ORDER} />
                    </div>
                  </div>
                </CardFooter>
              )}
            </Card>
          </div>
          <div className="col-sm-5 col-md-4 pull-left order-view hide-in-mobile">
            <Card>
              <CardBody className="p-1">
                <OrderCustomerInfo
                  typeOfOrder={this.props.typeOfOrder}
                  orderInfor={orderInfor}
                  isLocking={isLocking}
                  msgLocking={msgLocking}
                  isEditable={isEditable}
                  unlockOrder={this.unlockOrderClick}
                />
              </CardBody>
            </Card>
          </div>
          <OrderApproveCfm
            requesting={requesting}
            messages={messages}
            errors={errors}
            isApprove={this.state.modalApprove}
            orderInfor={orderInfor}
            onClose={this.toggleApprove}
            approveOrderClick={this.approveOrderClick}
            setOrderInfor={this.props.setOrderInfor}
          />
          <OrderHistory
            isOpen={this.state.modalHistory}
            onClose={this.closeDlgHistory}
            searchOrderHistoryData={this.searchOrderHistoryData}
            orderHistory={this.props.orderHistory}
            confirmReceivedMoney={this.confirmReceivedMoney}
          />
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customerInfor: state.order.customerInfor,
  orderInfor: state.order.orderInfor,
  errors: state.order.errors,
  messages: state.order.messages,
  warnings: state.order.warnings,
  requesting: state.order.requesting,
  typeOfOrder: state.order.typeOfOrder,
  orderId: state.order.orderId,
  orderHistory: state.order.orderHistory,
})

const connected = connect(mapStateToProps,
  {
    setIsLoading: orderActions.setIsLoading,
    setTypeOrder: orderActions.setTypeOrder,
    setOrderId: orderActions.setOrderId,
    setMode: orderActions.setMode,
    setOrderInfor: orderActions.setOrderInfor,
    getOrderDetails: orderActions.getOrderDetails,
    deleteOrder: orderActions.deleteOrder,
    cancelOrder: orderActions.cancelOrder,
    processOrder: orderActions.processOrder,
    approveOrder: orderActions.approveOrder,
    convertOrder: orderActions.convertOrder,
    revertOrder: orderActions.revertOrder,
    returnOrder: orderActions.returnOrder,
    unlockOrder: orderActions.unlockOrder,
    setCallbackFunc: orderActions.setCallbackFunc,
    loadOrderHistory: orderActions.loadOrderHistory,
    loadOrderExport: orderActions.loadOrderExport,
    loadOrderExcel: orderActions.loadOrderExcel,
    SetOrderConfirmMoney: orderActions.SetOrderConfirmMoney
  })(OrderDetails)

const formed = reduxForm({
  form: 'order',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Order/OrderDetails.js